import { render, staticRenderFns } from "./editarEvento.vue?vue&type=template&id=a27a56ec&scoped=true&"
import script from "./editarEvento.vue?vue&type=script&lang=js&"
export * from "./editarEvento.vue?vue&type=script&lang=js&"
import style0 from "./editarEvento.vue?vue&type=style&index=0&id=a27a56ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a27a56ec",
  null
  
)

export default component.exports